export default __webpack_public_path__ + "cd89be70fbcf8588bb1dd5b0a7d3f018.png";